import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '@/layout'

export const constantRoutes = [
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },

  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'Home',
      component: () => import('@/views/home/index'),
      meta: { title: '太仓港国际货运有限公司 - 首页', icon: 'dashboard'}
    }]
  },
  {
    path: '/tpit',
    component: Layout,
    children: [{
      path: 'introduction',
      name: 'Introduction',
      component: () => import('@/views/introduction/index'),
      meta: { title: '太仓港国际货运有限公司 - 简介', icon: 'dashboard'}
    },
    {
      path: 'contact',
      name: 'Contact',
      component: () => import('@/views/contact/index'),
      meta: { title: '太仓港国际货运有限公司 - 联系我们', icon: 'dashboard'}
    }]
  },
  {
    path: '/partner',
    component: Layout,
    children: [{
      path: 'tcsbggs',
      name: 'tcsbggs',
      component: () => import('@/views/partner/tcsbggs/index'),
      meta: { title: '太仓港国际货运有限公司 - 伙伴 - 太仓市报关公司', icon: 'dashboard'}
    },
    {
      path: 'jggjmy',
      name: 'jggjmy',
      component: () => import('@/views/partner/jggjmy/index'),
      meta: { title: '太仓港国际货运有限公司 - 伙伴 - 太仓金港国际贸易技术服务有限公司', icon: 'dashboard'}
    },
    {
      path: 'ytgjcbdl',
      name: 'ytgjcbdl',
      component: () => import('@/views/partner/ytgjcbdl/index'),
      meta: { title: '太仓港国际货运有限公司 - 伙伴 - 太仓远太国际船舶代理有限公司', icon: 'dashboard'}
    }]
  }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
